export default __webpack_public_path__ + "static/media/arrow.ae0c6f03.svg";